// extracted by mini-css-extract-plugin
export default {"loadingContainer":"WalletLoadingSkeleton_loadingContainer__YANzy"};